// Fields on a campaign object that map 1:1 into the CreateCampaign brief form.
const BRIEF_FIELDS = [
  'clientName', 'launchDate', 'campaignName', 'campaignGoal', 'goalDetails',
  'offer', 'cta', 'landingPageUrl',
  'ageRange', 'location', 'whoIsThisPerson', 'mainProblem', 'whatTheyWant',
  'interests', 'customAudiences', 'exclusions',
  'awarenessLevel', 'triedAndFailed', 'exactLanguage',
  'compellingFact', 'proofCredentials', 'bigPromise',
  'beforeState', 'afterState', 'emotionalPayoff', 'objections',
  'keyPhrases', 'phoneNumber', 'deadline', 'socialProof', 'guarantee',
  'otherRequirements',
  'dailyBudget', 'campaignDuration', 'startDate', 'endDate', 'placements'
];

/**
 * Build a router-state prefill payload for CreateCampaign from a campaign object
 * (e.g. a duplicated draft returned by the backend). Carries over the brief
 * fields, platform, and any saved ads.
 *
 * @param {object} campaign  A campaign object (flat data shape).
 * @param {object} [opts]
 * @param {string} [opts.notice]  Toast message to show on arrival.
 */
export function buildCampaignPrefill(campaign, opts = {}) {
  const formData = {};
  BRIEF_FIELDS.forEach((field) => {
    if (campaign[field] !== undefined && campaign[field] !== null) {
      formData[field] = campaign[field];
    }
  });

  return {
    prefill: {
      formData,
      platform: campaign.platform || null,
      savedAds: Array.isArray(campaign.ads) ? campaign.ads : [],
      currentAdIndex: 0,
      notice: opts.notice || null
    }
  };
}
